import styled from "styled-components";

import { Button as StyledButton } from "components/atoms/Button";
import { colourScheme } from "utils/styling/colours";

export const ScrollableTable = styled.table`
    max-height: 600px;
    overflow-y: auto;
    display: block;
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 1rem;

    thead {
        background-color: ${colourScheme.primary};
        color: ${colourScheme.white};
    }

    th,
    td {
        padding: 0.5rem;
        border: 1px solid ${colourScheme.secondary};
        text-align: left;
    }

    tbody {
        display: block;
        max-height: 600px;
        overflow-y: auto;
    }

    thead,
    tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    @media (max-width: 600px) {
        th:nth-child(2),
        td:nth-child(2),
        th:nth-child(3),
        td:nth-child(3),
        th:nth-child(4),
        td:nth-child(4) {
            display: none;
        }
    }
`;

export const Th = styled.th`
    padding: 1rem;
`;

export const Td = styled.td`
    padding: 1rem;
`;

export const Tr = styled.tr`
    &:nth-child(odd) {
        background-color: ${colourScheme.primary};
    }

    &:nth-child(even) {
        background-color: ${colourScheme.primaryDark};
    }

    cursor: pointer;
    transition: background-color 0.3s ease;
    &:hover {
        background-color: ${colourScheme.primaryLight};
    }
`;

export const Button = styled(StyledButton)`
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
`;

export const ButtonContainer = styled.td`
    padding: 0.5rem;
`;
